import { Injectable } from '@angular/core';
import { RoleMappingInfoDTO, UserAccountClient } from '../models/models.swagger.generated';
import { Observable, asapScheduler, catchError, of, scheduled, tap } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class RoleService {

  public roleMappingInfo: RoleMappingInfoDTO;
  constructor(private accountClient: UserAccountClient,
    private authService: AuthService) {
  }

  public getRoleMappingInfo(): Observable<RoleMappingInfoDTO> {
    if (this.roleMappingInfo) {
      return of(this.roleMappingInfo);
    }
    if (!this.authService.isUserAdminOrConfigurationAdminOrAssetAdmin()) {
      this.roleMappingInfo = {} as RoleMappingInfoDTO;
      return of(this.roleMappingInfo);
    }
    return this.accountClient.getRoleMappingInfo()
      .pipe(
        tap((roleMappingInfo: RoleMappingInfoDTO) => {
          this.roleMappingInfo = roleMappingInfo;
        }),
        catchError((error: any) => scheduled<RoleMappingInfoDTO>(error, asapScheduler))
      );
  }
}
